// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2znto","list":"styles_list__72mwy"};